module.exports = __webpack_public_path__ + "static/ring_of_protection-c52717ec8262ed2ebc05390fc462e358.jpeg";